
import Checkbox from "@/components/form/checkbox.vue";
import Radio from "@/components/form/radio.vue";
import Item from "@/components/item.vue";
import mainContent from "@/components/mainContent.vue";
import { defineComponent, reactive, toRefs } from "vue";
import {
  data as filterData,
  machine_type_filter,
  action_method_filter,
} from "@/views/choose/filterValue";
import { machineTypeProps, stateProps } from "@/model/optionsModel";
import {
  optionsList,
  formatFormValuebeforeSubmit,
  ifMainValueIsUndefindTip,
} from "./data";
import { useRouter } from "vue-router";
import { saveRepo } from "@/service/api";

const isObject = (obj: machineTypeProps) => {
  return Object.prototype.toString.call(obj) === "[object Object]";
};

export default defineComponent({
  name: "choose",
  components: { mainContent, Radio, Item, Checkbox },
  setup() {
    const allList = reactive(optionsList);
    const router = useRouter();

    const state: stateProps = reactive({
      form: {
        tool: "",
        shape: { type: "", tag: "" },
        component_weight: {
          "0.1-1.3kg": 0,
          "1.4-3.6kg": 0,
          "3.7-6.6kg": 0,
        },
        component_size: {
          length: 0,
          height: 0,
          width: 0,
        },
        component_nums: "",
        machine_type: [],
        action_method: { type: "", tag: [""] },
        service_type: [],
        beat: "",
      },
      targetType: [],
      actionTargetType: [],
      tip: {},
      changeMachineTypeChose(arr: machineTypeProps[], type: string[]) {
        state.targetType = type;
        // state.form.machine_type = [arr[0]];
      },
      changeActionMethods(arr: machineTypeProps, type: string[]) {
        state.actionTargetType = type;
        // state.form.action_method = arr;
      },
    });

    return {
      ...toRefs(allList),
      ...toRefs(state),
      router,
    };
  },
  methods: {
    handleFocus(obj: string, key: string) {
      if (~~this.form[obj][key] === 0) {
        this.form[obj][key] = "";
      }
    },
    handleBlur(obj: string, key: string, maxValue: string) {
      if (!this.form[obj][key]) {
        this.form[obj][key] = 0;
      } else if (maxValue && ~~this.form[obj][key] > ~~maxValue) {
        this.form[obj][key] = maxValue;
      }
    },
    async saveResult(obj: any) {
      saveRepo(obj);
    },
    async submitAction() {
      const { status, data } = this.beforeSubmitCheck();
      if (!status) return;
      let finishFilter: string[] = [];
      if (this.filterActionMethodList.length) {
        finishFilter = this.actionTargetType.filter(
          (v) => this.form.action_method.tag.indexOf(v) > -1
        );
      } else {
        finishFilter = this.actionTargetType;
      }
      const compare = Object.keys(this.form.component_weight).sort((a, b) => {
        return this.form.component_weight[b] - this.form.component_weight[a];
      });

      const serise = finishFilter[0].split("-")[1];
      const type = filterData.component_height[compare[0]];
      const result = "CoSi-" + type + serise;
      await this.saveResult({ ...data, result });
      this.router.push({ path: "/result/" + result });
    },
    beforeSubmitCheck() {
      let data = {};
      this.tip = {};

      for (let i in this.form) {
        if (isObject(this.form[i]) && !formatFormValuebeforeSubmit[i]) {
          data[i] = this.form[i].type ? this.form[i].type : "";
        } else if (formatFormValuebeforeSubmit[i]) {
          data[i] = formatFormValuebeforeSubmit[i](this.form[i]);
        } else {
          data[i] = this.form[i];
        }

        if (data[i] === "") {
          if (i == "action_method" && !this.filterActionMethodList.length) {
            continue;
          }
          if (ifMainValueIsUndefindTip[i]) {
            this.tip[i] = ifMainValueIsUndefindTip[i];
          }
        }
      }
      data = {
        ...JSON.parse(sessionStorage.getItem("form") || "{}"),
        ...data,
      };

      return { status: !Object.keys(this.tip).length, data };
    },
  },
  computed: {
    filterMachineList() {
      if (!this.form.shape.tag) return [];
      const shapeTag: string = this.form.shape.tag;
      const filterResult: string[] = filterData.shape[shapeTag];

      let filters: string[] = [];

      for (let i of filterResult) {
        if (machine_type_filter[i]) {
          filters = filters.concat(machine_type_filter[i]);
        }
      }
      let set = Array.from(new Set(filters));
      const result: machineTypeProps[] = set.map((item) => {
        return {
          ...this.machineList[item],
          tag: filterData.machine_type[this.machineList[item].tag],
        };
      });

      result.push({ type: "其他", tag: ["CoSi-U", "CoSi-T", "CoSi-M"] });
      this.changeMachineTypeChose(result, filterResult);

      return result;
    },
    filterActionMethodList() {
      if (!this.form.machine_type.length) return [];
      const result: machineTypeProps[] = [];
      const allType = this.form.machine_type.map((item) => item.tag);

      const hasChoseMachineType = Array.from(allType.flat());
      const sameType: string[] = this.targetType.filter(
        (v) => hasChoseMachineType.indexOf(v) > -1
      );

      for (let i of sameType) {
        const filterResult: string[] = action_method_filter[i];
        if (filterResult) {
          filterResult.map((item) => {
            result.push({
              ...this.actionMethodsList[item],
              tag: filterData.action_method[this.actionMethodsList[item].tag],
            });
          });
        }
      }
      this.changeActionMethods(result[0], sameType);
      return result;
    },
  },
});
